import React from 'react';
import { Card, Tabs } from 'antd';
import SettlementBillRerun from './SettlementBillRerun';
import BillingPeriodOverviewPage from './BillingPeriodOverviewPage';
import BillingTestPage from './BillingTestPage';
import BillingConfigPage from './BillingConfigPage';
import BillExportHistory from './BillExportHistory';

const { TabPane } = Tabs;

const BillOpsPage: React.FC = () => {
  return (
    <div className="p-6">
      <Card>
        <Tabs defaultActiveKey="bill-rerun" type="card">
          <TabPane tab="账单重跑" key="bill-rerun">
            <SettlementBillRerun />
          </TabPane>
          <TabPane tab="账期管理" key="billing-period">
            <BillingPeriodOverviewPage />
          </TabPane>
          <TabPane tab="账单测试" key="billing-test">
            <BillingTestPage />
          </TabPane>
          <TabPane tab="账单配置" key="billing-config">
            <BillingConfigPage />
          </TabPane>
          <TabPane tab="导出历史" key="export-history">
            <BillExportHistory />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default BillOpsPage;
